import React, { useState, useEffect } from 'react';
import { Cookies } from '../index.js';
import { alert_error, alert_success } from '../AppContext';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import { SlArrowRight } from "react-icons/sl";
import AdSense from 'react-adsense';
import Swal from 'sweetalert2';
import Language_i18 from '../js/useNationalLanguage.jsx';

const YourComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = Language_i18();

  // Đối tượng dịch thuật chứa tất cả văn bản giao diện
  const translations = {
    vi: {
      currentPhone: "Số điện thoại hiện tại là:",
      notSet: "Chưa có",
      verificationStatus: "Trạng thái xác thực:",
      guide: "Hướng dẫn",
      step1: "Bước 1: Thêm số điện thoại",
      phonePlaceholder: "Nhập số điện thoại để rút hoặc nạp Coins",
      confirmButton: "✔️ Xác nhận",
      processing: "Vui lòng đợi một lát 😊",
      enterInfo: "Vui lòng điền đầy đủ thông tin",
      step2: "Bước 2: Xác nhận",
      openTelegram: "Mở Telegram",
      finalStep: "Bước cuối: Ấn xác nhận",
      success: "Thành công",
      error: "Đã xảy ra lỗi, vui lòng liên hệ admin",
      reset: "Đặt lại",
      agree: "Đồng ý",
      cancel: "Từ chối",
      notification: "Thông báo",
      blankInput: "Bỏ trống khung nhập đồng nghĩa với xóa số điện thoại cũ đi",
      editAgain: "Sửa lại",
      continue: "Tiếp tục",
    },
    en: {
      currentPhone: "Current phone number is:",
      notSet: "Not set",
      verificationStatus: "Verification status:",
      guide: "Guide",
      step1: "Step 1: Add phone number",
      phonePlaceholder: "Enter phone number to withdraw or deposit Coins",
      confirmButton: "✔️ Confirm",
      processing: "Please wait a moment 😊",
      enterInfo: "Please enter all information",
      step2: "Step 2: Confirm",
      openTelegram: "Open Telegram",
      finalStep: "Final step: Press confirm",
      success: "Success",
      error: "An error occurred, please contact admin",
      reset: "Reset",
      agree: "Agree",
      cancel: "Cancel",
      notification: "Notification",
      blankInput: "Leaving the input blank means deleting the old phone number",
      editAgain: "Edit again",
      continue: "Continue",
    }
  };

  const [phoneData, setPhoneData] = useState(null);
  const [isTelegramOpen, setIsTelegramOpen] = useState(false);
  const [phoneInput, setPhoneInput] = useState('');
  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(0);
  const [isProcessing2, setIsProcessing2] = useState(0);
  const [buttonLabel, setButtonLabel] = useState(translations[lang]?.confirmButton);
  const [buttonLabel2, setButtonLabel2] = useState(translations[lang]?.finalStep);

  // Xử lý phản hồi từ API
  const processResponse = (response) => {
    const info = response.data;
    const status = info.status;
    setIsProcessing2(0);
    setIsProcessing(0);
    if (status == 0) {
      setButtonLabel(translations[lang]?.continue);
      setButtonLabel2(translations[lang]?.continue);
      alert_error(info.message);
    } else if (status == 5) {
      deletePhoneConfirmation(info.message);
    } else if (status == 1) {
      if (info.message2) {
        setMessage(info.message2);
      } else {
        setButtonLabel2(translations[lang]?.success);
      }
      setButtonLabel(translations[lang]?.editAgain);
      alert_success(info.message);
    } else {
      setButtonLabel2(translations[lang]?.error);
      setButtonLabel(translations[lang]?.error);
    }
    if (info.redirect) {
      setTimeout(() => {
        window.location.href = info.redirect;
      }, 1700);
    }
  };

  // Gửi yêu cầu thêm/sửa số điện thoại
  const onSubmit = (event) => {
    event.preventDefault();
    setIsProcessing(1);
    setButtonLabel(translations[lang]?.processing);
    const apikey = Cookies.get('apikey');
    if (!apikey) {
      alert_error(translations[lang]?.enterInfo);
      setIsProcessing(0);
      setButtonLabel(translations[lang]?.enterInfo);
      return;
    }
    if (!phoneInput) {
      deletePhoneConfirmation(translations[lang]?.blankInput);
      setIsProcessing(0);
      setButtonLabel(translations[lang]?.enterInfo);
      return;
    }
    axios
      .post('https://hust.media/jop/telegram/phone_process.php', {
        inputlienket: phoneInput,
        apikey: apikey,
        service: 'edit'
      })
      .then(response => processResponse(response))
      .catch(error => {
        alert_error(error);
        setIsProcessing(0);
      });
  };

  // Xóa số điện thoại
  const deleteProcess = () => {
    setIsProcessing(1);
    setButtonLabel(translations[lang]?.processing);
    const apikey = Cookies.get('apikey');
    if (!apikey) {
      alert_error(translations[lang]?.enterInfo);
      setIsProcessing(0);
      setButtonLabel(translations[lang]?.enterInfo);
      return;
    }
    axios
      .post('https://hust.media/jop/telegram/phone_process.php', {
        inputlienket: phoneInput,
        apikey: apikey,
        service: 'delete'
      })
      .then(response => processResponse(response))
      .catch(error => {
        alert_error(error);
        setIsProcessing(0);
      });
  };

  // Xác nhận xóa số điện thoại
  const deletePhoneConfirmation = (value) => {
    setButtonLabel(translations[lang]?.continue);
    Swal.fire({
      title: translations[lang]?.notification,
      text: value,
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: translations[lang]?.agree,
      cancelButtonText: translations[lang]?.cancel,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsProcessing(1);
        setButtonLabel(translations[lang]?.processing);
        deleteProcess();
      }
    });
  };

  // Mở Telegram
  const openTelegram = () => {
    setIsTelegramOpen(true);
  };

  // Xác nhận qua Telegram
  const confirmTelegram = (event) => {
    event.preventDefault();
    setIsProcessing2(1);
    setButtonLabel2(translations[lang]?.processing);
    const apikey = Cookies.get('apikey');
    if (!apikey || !phoneInput) {
      alert_error(translations[lang]?.enterInfo);
      setIsProcessing2(0);
      setButtonLabel2(translations[lang]?.enterInfo);
      return;
    }
    axios
      .get(`https://hust.media/jop/telegram/xacthuctele.php?apikey=${apikey}&phone=${phoneInput}`)
      .then(response => processResponse(response))
      .catch(error => {
        alert_error(error);
        setIsProcessing2(0);
      });
  };

  // Lấy dữ liệu số điện thoại
  const fetchPhoneData = () => {
    const apikey = Cookies.get('apikey');
    axios
      .get(`https://hust.media/jop/telegram/getsdt.php?apikey=${apikey}`)
      .then(response => {
        const info = response.data;
        if (info.status == 0) {
          alert_error(info.message);
        } else if (info.status == 1) {
          setPhoneData(info);
        }
        if (info.redirect) {
          setTimeout(() => {
            navigate(info.redirect);
          }, 200);
        }
      })
      .catch(error => console.log(error));
  };

  // Tự động cập nhật dữ liệu định kỳ
  useEffect(() => {
    fetchPhoneData(); // Gọi ngay lần đầu
    const timer = setInterval(() => {
      const currentPath = window.location.pathname;
      if (currentPath !== '/reactapp/themsdt') {
        clearInterval(timer);
      } else {
        fetchPhoneData();
      }
    }, 3700);

    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <div className="max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block' }}
            format='horizontal'
            responsive='false'
          />
        </div>
      </div>
      {phoneData && (
        <div className="row align-items-center max-w-md mx-auto">
          <div className="col mb-0">
            <div className="col text-left">
              <div className="text-center mt-1">
                {translations[lang]?.currentPhone}
                {phoneData.phone ? phoneData.phone : translations[lang]?.notSet}
              </div>
              {phoneData.checkphone && (
                <div className="text-center">
                  {translations[lang]?.verificationStatus} {phoneData.checkphone}
                </div>
              )}
            </div>
          </div>
          <div className="col mb-0">
            <div className="col text-right mr-2">
              <a href="/shop/content/blog_posts/dangbaiok/11526" target="_blank" className="btn btn-sm btn-primary">
                {translations[lang]?.guide}
              </a>
            </div>
          </div>
        </div>
      )}
      <div className="max-w-md mx-auto">
        <div className="mt-1 space-y-2 border-2 mx-2 px-2 py-2 rounded-lg text-gray-700">
          <label className="block font-medium text-sm mx-auto" htmlFor="phoneInput">
            {translations[lang]?.step1}
          </label>
          <div className="relative focus-within:text-gray-900 dark:focus-within:text-gray-800">
            <input
              className="pl-11 text-gray-800 pr-4 py-2 border-gray-600 rounded-md focus:border-gray-400 focus:ring focus:ring-gray-800 ring-gray-400 ring focus:ring-offset-2 focus:ring-offset-white dark:border-gray-600 dark:bg-primary-darker dark:focus:ring-offset-dark-eval-1 block w-full"
              id="phoneInput"
              name="phoneInput"
              required
              value={phoneInput}
              onChange={(e) => setPhoneInput(e.target.value)}
              placeholder={translations[lang]?.phonePlaceholder}
              type="text"
            />
          </div>
          <button
            disabled={isProcessing == 1}
            onClick={onSubmit}
            className="mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-1 w-full dark:bg-purple-400 dark:text-white"
          >
            <div className="flex items-center justify-between flex-1">
              {isProcessing == 1 && <div className="spinner-border" role="status"></div>}
              <span className="text-lg font-medium text-white">{buttonLabel}</span>
              <div className="text-xl">{'\u27A4'}</div>
            </div>
          </button>
        </div>
        {message && (
          <div className="mt-0">
            <div className="items-center mt-4 flex-col mx-4">
              <div className="border-1 break-inside relative overflow-hidden flex flex-col justify-between space-y-2 text-sm rounded-xl p-3 mb-4 bg-[#5E17F4] text-white">
                <span className="uppercase text-xs text-[#D2BDFF]">{translations[lang]?.step2}</span>
                <div className="flex flex-row items-center space-x-3">
                  <span className="text-base font-medium">{message}</span>
                </div>
                {isTelegramOpen ? (
                  <button
                    disabled={isProcessing2 == 1}
                    onClick={confirmTelegram}
                    className="flex items-center justify-center text-xs font-medium rounded-full px-4 py-2 space-x-1 bg-white text-black"
                  >
                    {isProcessing2 == 1 && <div className="spinner-border" role="status"></div>}
                    <span className="text-base">{buttonLabel2}</span>
                    <SlArrowRight />
                  </button>
                ) : (
                  <div className="flex justify-between items-center">
                    <span>t.me/hustmediabot</span>
                    <a style={{ textDecoration: 'none' }} target="_blank" href="https://t.me/hustmediabot">
                      <button onClick={openTelegram} className="flex items-center justify-center text-xs font-medium rounded-full px-2 py-2 space-x-1 bg-white text-black">
                        <span className="text-base px-1">{translations[lang]?.openTelegram}</span>
                        <SlArrowRight />
                      </button>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YourComponent;